module.exports = __webpack_public_path__ + "img/45.6.CODm.1c39ca79.png";